import { Component, OnInit } from '@angular/core';
import { LoadingService, LoadingType } from '../services/loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {
  constructor(public loadingService: LoadingService) {}

  ngOnInit(): void {}

  get loading(): boolean {
    return this.loadingService.loading;
  }

  get loadingType(): LoadingType {
    return this.loadingService.loadingType;
  }

  get showProgress(): boolean {
    return this.loadingService.showProgress;
  }

  get loadingProgress(): number {
    return this.loadingService.loadingProgress;
  }

  get loadingMessage(): string {
    return this.loadingService.loadingMessage;
  }

  // New: Document scan state
  // Possible values: 'pending', 'success', 'error'
  get scanState(): 'pending' | 'success' | 'error' {
    // You can extend this logic to use a service or @Input if needed
    if ((this.loadingType as any) === 'document-scan') {
      if (this.loadingProgress >= 100) {
        // You can add more logic to distinguish between success and error
        // For now, assume success if progress is 100
        return 'success';
      } else if (this.loadingProgress < 0) {
        return 'error';
      } else {
        return 'pending';
      }
    }
    return 'pending';
  }
}
